import { FormattedMessage } from 'react-intl'

import { IconPencilSquare } from '@gto/ui/assets'
import { IconButton } from '@gto/ui/icon-button'
import { EyeSlashIcon } from '@gto/ui/icons/outline'
import { Input } from '@gto/ui/input'
import { Skeleton } from '@gto/ui/skeleton'
import { Typography } from '@gto/ui/typography'

import { ChangePasswordForm } from './change-password-form'

export type ChangePasswordWidgetProps = {
  isActive: boolean
  isPending: boolean
  onOpen: () => void
  onClose: () => void
}

export const ChangePasswordWidget = ({
  isActive,
  isPending,
  onOpen,
  onClose,
}: ChangePasswordWidgetProps) => {
  // Show form when active
  if (isActive) {
    return <ChangePasswordForm onClose={onClose} />
  }

  // Show password field when not active (view mode)
  return (
    <div>
      {isPending ? (
        <>
          <Skeleton
            variant="text"
            width="120px"
          />
          <Skeleton
            variant="text"
            width="150px"
          />
        </>
      ) : (
        <>
          <Typography
            gutterBottom
            className="px-2"
            color="text.secondary"
            component="p"
            variant="body2"
          >
            <FormattedMessage id="common.labels.password" />
          </Typography>
          <div className="flex items-center gap-3">
            <Input
              readOnly
              type="password"
              value="••••••••"
              endAddon={
                <IconButton size="small">
                  <EyeSlashIcon />
                </IconButton>
              }
            />
            <button
              className="flex cursor-pointer items-center border-none bg-transparent p-0 text-success-main hover:opacity-80"
              onClick={onOpen}
            >
              <IconPencilSquare />
            </button>
          </div>
        </>
      )}
    </div>
  )
}
